import type { Event } from '@patsnap/tahiti-core';
import type { EmbodimentClaimFeaturesState } from '../types';

/**
 * 实施例权利要求特征服务
 * 用于管理和处理实施例生成过程中的权利要求特征
 */
export const EmbodimentClaimFeaturesService = Symbol.for('EmbodimentClaimFeaturesService');

export interface EmbodimentClaimFeaturesService {
    /**
     * 状态变更事件
     * 当权利要求特征状态发生变化时触发
     */
    readonly onStateChange: Event<EmbodimentClaimFeaturesState>;

    /**
     * 获取当前模型数据
     * @returns 权利要求特征状态
     */
    getModelData(): EmbodimentClaimFeaturesState;

    /**
     * 初始化权利要求特征
     * 从系统中加载并初始化权利要求特征数据
     */
    initClaimFeatures(): Promise<void>;
}
